module.exports = __webpack_public_path__ + "img/paint-palette.2574d635.svg";